export default __webpack_public_path__ + "locales/zh-CN/PeopleTranslations.json?hash=342de088fb886139a41aedaa21d59310";